const FETCH_STORY_ADS = 'studioStoryAd/FETCH_STORY_ADS';
const CREATE_STORY_AD = 'studioStoryAd/CREATE_STORY_AD';
const PATCH_STORY_AD = 'studioStoryAd/PATCH_STORY_AD';
const RESET = 'studioStoryAd/RESET';
const FETCH_EPISODES = 'studioStoryAd/FETCH_EPISODES';

const FETCH_DONATE_VOUCHERS = 'studioStoryAd/FETCH_DONATE_VOUCHERS';
const FETCH_DONATE_VOUCHER_RECOMMENDATION =
  'studioStoryAd/FETCH_DONATE_VOUCHER_RECOMMENDATION';

export default {
  FETCH_STORY_ADS,
  CREATE_STORY_AD,
  PATCH_STORY_AD,
  RESET,
  FETCH_EPISODES,
  FETCH_DONATE_VOUCHERS,
  FETCH_DONATE_VOUCHER_RECOMMENDATION,
};



// WEBPACK FOOTER //
// ./src/app/redux/studio/storyAd/types.js